const LogLevel = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3,
};

class Logger {
  constructor(level = LogLevel.INFO) {
    this.level = level;
  }

  shouldLog(level) {
    return level <= this.level;
  }

  formatMessage(level, message) {
    return `[${Object.keys(LogLevel)[level]}] ${message}`;
  }

  error(message, ...args) {
    if(this.shouldLog(LogLevel.ERROR)) {
      console.error(this.formatMessage(LogLevel.ERROR, message), ...args);
    }
  }

  warn(message, ...args) {
    if(this.shouldLog(LogLevel.WARN)) {
      console.warn(this.formatMessage(LogLevel.WARN, message), ...args);
    }
  }

  info(message, ...args) {
    if(this.shouldLog(LogLevel.INFO)) {
      console.log(this.formatMessage(LogLevel.INFO, message), ...args);
    }
  }

  debug(message, ...args) {
    if (this.shouldLog(LogLevel.DEBUG)) {
      console.log(this.formatMessage(LogLevel.DEBUG, message), ...args);
    }
  }

  setLevel(level) {
    this.level = level;
  }
}

const logger = new Logger(LogLevel.DEBUG);

export default logger;
